<template>
    <v-card>
        <v-form ref="formnewactuacion" v-model="valid" lazy-validation>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 sm4>
                        <v-text-field
                            v-model="form.number_id"
                            prepend-icon="subtitles"
                            label="Rif del cliente"
                            @keyup="tipoPersona"
                            @change="searchTypeDocuments"
                            :rules="[v => !!v || 'Rif es requerido', v => (v.charAt(0) == 'V' || v.charAt(0) == 'E' || v.charAt(0) == 'P' || v.charAt(0) == 'J' || v.charAt(0) == 'G') || 'La personalidad debe ser V,P,J,E,G', v => v.length == 10 || 'Debe tener 10 caracteres']"
                            mask="A-########-#"
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8>
                        <v-text-field
                            v-model="form.client"
                            prepend-icon="domain"
                            label="Razon social del Cliente"
                            :rules="[v => !!v || 'Cliente es requerido']"
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-select
                            :disabled="activeRif"
                            :items="documentsType"
                            v-model="form.document_type_father"
                            @change="getChildDocument"
                            menu-props="auto"
                            label="Tipo de Actuación"
                            prepend-icon="find_in_page"
                            :rules="[v => !!v || 'Tipo de Actuación es requerido']"
                            item-text="padre"
                            item-value="padre_document_type_id"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-select
                            :disabled="activeRif"
                            :items="itemChildDocument"
                            v-model="form.document_type"
                            @change="getPriceDocument"
                            menu-props="auto"
                            label="Tipo de Documento"
                            prepend-icon="find_in_page"
                            :rules="[v => !!v || 'Tipo de Documento es requerido']"
                            item-text="document_type_name"
                            item-value="concept_document_type_id"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <v-text-field
                            :disabled="activeRif"
                            v-model="form.pages"
                            prepend-icon="view_carousel"
                            label="Num Paginas"
                            :rules="[v => !!v || 'Num Paginas es requerido']"
                            required
                            mask="###"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <v-menu
                            ref="menu"
                            lazy
                            :close-on-content-click="false"
                            v-model="menu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="fecha"
                        >
                            <v-text-field
                                :disabled="activeRif"
                                slot="activator"
                                label="Fecha"
                                v-model="computedDateFormattedFecha"
                                hint="DD/MM/YYYY formato"
                                prepend-icon="event"
                                :rules="[v => !!v || 'Fecha es requerido']"
                                required
                                readonly
                            ></v-text-field>
                            <v-date-picker :max="new Date().toISOString().slice(0,10)" v-model="form.date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.menu.save(fecha)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>

                    <v-flex xs12 sm4>
                      <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                        <div class="v-input__prepend-outer">
                          <div class="v-input__icon v-input__icon--prepend">
                          </div>
                        </div>
                        <div class="v-input__control">
                          <div class="v-input__slot">
                            <div class="v-text-field__slot">
                              <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto Actuación</label>
                              <vue-numeric :read-only="activeRif" currency="BsS" v-model="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                            </div>
                          </div>
                          <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                              <div class="v-messages__wrapper"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex xs12 sm4>
                      <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                        <div class="v-input__prepend-outer">
                          <div class="v-input__icon v-input__icon--prepend">
                              <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                          </div>
                        </div>
                        <div class="v-input__control">
                          <div class="v-input__slot">
                            <div class="v-text-field__slot">
                              <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Precio del Servicio</label>
                              <vue-numeric read-only currency="BsS" :value="Number(getTotalPriceValue)" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                            </div>
                          </div>
                          <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                              <div class="v-messages__wrapper">
                                  Precio con IVA incluido
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>

                    <!-- seleccion del tipo de hoja -->
                    <v-flex xs12 pb-0 pt-0>
                        <v-radio-group :disabled="activeRif" v-model="form.tipo_hoja" row :rules="[v => !!v || 'Tipo de papel es requerido']">
                            <template v-slot:label>
                                <div><strong>Tipo de hojas:</strong></div>
                            </template>
                            <v-radio color="primary" value="SIN HOJAS">
                                <template v-slot:label>
                                <div><strong>Blanca</strong></div>
                                </template>
                            </v-radio>
                            <v-radio color="primary" value="DIGITAL">
                                <template v-slot:label>
                                <div><strong>Digital</strong></div>
                                </template>
                            </v-radio>
                            <v-radio color="primary" value="PROPIA">
                                <template v-slot:label>
                                <div><strong>Física</strong></div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-flex>

                    <!-- cuando es por DIGITAL -->
                    <v-flex v-if="form.tipo_hoja == 'DIGITAL'" xs12 pt-0 pb-0>
                        <v-subheader style="height: 20px" class="pa-0 mt-0">Ingrese la cantidad de hojas digitales a necesitar y el documento al cual sera aplicada</v-subheader>
                        <v-text-field
                            ref="cantidad"
                            @blur="verificarExistencia"
                            placeholder="0"
                            v-model="form.cantidad"
                            mask="####"
                            prepend-icon="library_books"
                            label="Cantidad a Solicitar"
                            :rules="[v => !!v || 'La cantidad es requerido']"
                            required
                        ></v-text-field>
                        <v-subheader style="height: 20px" class="pa-0 mt-0">{{ hojas_agremiado }} Hojas Disponible en stock, {{ cantidad_facturar }} a Facturar</v-subheader>
                    </v-flex>

                    <!-- hojas (desde hasta) - de tener hojas de seguridad -->
                    <v-flex v-if="form.tipo_hoja == 'PROPIA'" xs12 pt-0 pb-0>
                        <v-subheader style="height: 20px" class="pa-0 mt-0">Escriba el Número de hoja seguido de la tecla enter</v-subheader>
                        <v-combobox
                            :disabled="activeRif"
                            v-model="security_papers"
                            label="Número de hojas a utilizar"
                            chips
                            solo
                            multiple
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    :selected="data.selected"
                                    close
                                    @input="remove(data.item)"
                                >
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea
                            :disabled="activeRif"
                            v-model="form.subject"
                            prepend-icon="featured_play_list"
                            label="Finalidad"
                            auto-grow
                            :rules="[v => !!v || 'Finalidad es requerido']"
                            required
                            box
                            rows="1"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="primary darken-1" @click="submitForm">Solicitar</v-btn>
            </v-card-actions>
        </v-form>

         <v-dialog v-model="dialogValidPaper" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Validando Hoja de Seguridad...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-card>
</template>

<script>
import Form from 'vform'
import axios from 'axios'
import { mapGetters } from 'vuex'
import VueNumeric from 'vue-numeric'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    props: {
        loading: {
            type: Boolean,
            required: true
        },
        params: {
            type: Object,
            default: {}
        }
    },

    components: {
        VueNumeric
    },

    watch: {

        form (v){
            console.log(v, 'vform')
        },

        params (v) {
            this.form.document_type_father = v.document_type_id
            this.form.document_type = v.concept_document_type.id
            this.form.tipo_persona = v.concept_document_type.personality
            this.searchTypeDocuments2()
            this.paramsHome = v
        },

        security_papers(v){
            if(!this.security_delete){
                this.dialogValidPaper = true
                axios.post('/api/cliente/valid-security-paper', {number_paper: this.security_papers[this.security_papers.length - 1]}).then(resp => { 
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: `Hoja Número ${resp.data.papel} valida.`
                    })
                }).catch(error => {
                if(error.response.data.errors){
                    if(error.response.data.errors.papel){
                        this.remove(this.security_papers[this.security_papers.length - 1])
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: error.response.data.errors.papel
                        })
                    }
                }
                }).finally(() => this.dialogValidPaper = false)
            }
            this.security_delete = false
        }

    },
    
    data () {
        return {
            hojas_agremiado: 0,
            cantidad_facturar: 0,
            monto_total_hdigitales: 0,
            oldCantidad: 0,
            itemChildDocument: [],
            security_papers: [],
            documentsRequirementsChildSat: [],
            documentsType: [],
            security_delete: false,
            dialogValidPaper: false,
            valid: false,
            fecha: null,
            menu: false,
            activeRif: true,
            taxes: 16,
            paramsHome: {},
            form: new Form({
                cpc: '',
                document_type_father: '',
                document_type: '',
                client: '',
                number_id: '',
                subject: '',
                date: '',
                pages: '',
                tipo_hoja: '',
                tipo_persona: '',
                security_papers: [],
                amount: 0.00,
                cantidad: null
            })
        }
    },

    computed: {
        ...mapGetters({
            user: 'authUser',
            documentsRequirementsSat: 'getDocumentRequirementSat',
            // documentsRequirementsChildSat: 'getSatDocumentsTypeChild',
            // documentsType: 'getSatDocumentsType',
            document_price: 'getSatDocumentPrice',
        }),
        computedDateFormattedFecha () {
            return this.formatDate(this.form.date)
        },
        getTotalPriceValue () {
            return this.document_price + this.monto_total_hdigitales;
        },
        errorMessageExistsCpc () {
            if (this.user.length !== 0) {
                if (this.user.exist) {
                    if (!this.user.solvencia[0].solvente) {
                        return `Saldo Deudor: ${this.user.saldo_deudor}`
                    }
                }else{
                    return 'CPC no existe'
                }
            }

            return ''
        }
    },

    mounted () {
        this.loadingUserData()
        this.$store.dispatch('clearMessage')
        this.$store.dispatch('fetchSatDocumentsType')
    },

    methods: {

        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        async verificarExistencia() {
            if(this.oldCantidad != this.form.cantidad){
                this.$emit('loadingResponse', true)
                await axios.get(`/api/cliente/security-paper-electronic-available/${this.form.cantidad}`)
                    .then((resp) => {
                        console.log(resp.data)

                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: `${resp.data.cantidad_solicitada} hojas digitales disponibles!..`
                        })
                        this.hojas_agremiado = resp.data.hojas_agremiado
                        this.cantidad_facturar = resp.data.cantidad_facturar
                        this.monto_total_hdigitales = resp.data.monto_total
                        // this.dr = resp.data.dr
                        // this.dr.push({id: 'all', description: 'TODAS'})
                        // this.activeDr = true
                    })
                    .catch(e => {
                        console.log(e.response)
                            if (e.response.data.errors) {
                                if (e.response.data.errors.no_available) {
                                    this.$store.dispatch('responseMessage', {
                                        type: 'error',
                                        text: e.response.data.errors.no_available
                                    })
                                }else {
                                    this.$store.dispatch('responseMessage', {
                                        type: 'error',
                                        text: e.response.data.error
                                    })
                                }
                            }
                    })
                    .finally(() => this.$emit('loadingResponse', false));
            }
            this.oldCantidad = this.form.cantidad
        },

        tipoPersona () {
            if(this.form.number_id.charAt(0) == 'V' || this.form.number_id.charAt(0) == 'P' || this.form.number_id.charAt(0) == 'J' || this.form.number_id.charAt(0) == 'G' || this.form.number_id.charAt(0) == 'E'){
                this.form.tipo_persona = (this.form.number_id.charAt(0) == 'V' || this.form.number_id.charAt(0) == 'P' || this.form.number_id.charAt(0) == 'E') ? 'NATURAL' : 'JURIDICA'
                this.activeRif = false
            }else {
                this.form.number_id = ''
                this.activeRif = true
            }
        },

        async searchTypeDocuments () {
            if(this.form.number_id.length == 10){
                this.$emit('loadingResponse', true)
                await axios.post(`/api/sat/search-info-document-type`, { personalidad: this.form.tipo_persona })
                  .then(res => {
                      this.documentsType = res.data.documents_type;
                      this.documentsRequirementsChildSat = res.data.documents_type_childs;
                  })
                  .finally(() => this.$emit('loadingResponse', false));
            }else if(this.form.number_id.length < 10){
                this.activeRif = true
            }
        },

        async searchTypeDocuments2 () {
            this.$emit('loadingResponse', true)
            await axios.post(`/api/sat/search-info-document-type`, { personalidad: this.form.tipo_persona })
                  .then(res => {
                      this.documentsType = res.data.documents_type;
                      this.documentsRequirementsChildSat = res.data.documents_type_childs;
                      this.getChildDocument2()
                  })
                  .finally(() => this.$emit('loadingResponse', false));
        },
            
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async loadingUserData() {
            this.$emit('loadingResponse', true)
            await this.$store.dispatch('fetchUser')
            this.$nextTick(() => {
                this.$emit('loadingResponse', false)
            })
        },

        async validCpcRuap() {
            this.$emit('loadingResponse', true)
            await this.$store.dispatch('validCpcRuap', this.form.cpc)
            this.$nextTick(() => {
                this.$emit('loadingResponse', false)
            })
        },

        async getPriceDocument() {
            // console.log("entro en el price")
            this.$emit('loadingResponse', true)
            await this.$store.dispatch('fetchPriceDocument', { document_type: this.form.document_type, personalidad: this.form.tipo_persona })
            this.$nextTick(() => {
                this.$emit('loadingResponse', false)
            })
        },

        async getChildDocument() {
            this.$emit('loadingResponse', true)
            this.itemChildDocument = this.documentsRequirementsChildSat.filter(drcs => { return drcs.padre_document_type_id == this.form.document_type_father })
            this.$nextTick(() => {
                this.$emit('loadingResponse', false)
            })
        },

        async getChildDocument2() {
            this.$emit('loadingResponse', true)
            this.itemChildDocument = this.documentsRequirementsChildSat.filter(drcs => { return drcs.padre_document_type_id == this.form.document_type_father })
            this.$nextTick(() => {
                this.getPriceDocument()
                this.$emit('loadingResponse', false)
            })
        },

        remove (item) {
            const index = this.security_papers.indexOf(item)
            if (index >= 0) this.security_papers.splice(index, 1)
            this.security_delete = true
        },

        async submitForm() {
            if (this.$refs.formnewactuacion.validate()) {
                if(this.user.unionize != null) {
                    this.form.cpc = this.user.unionize.cpc
                }
                if(this.form.tipo_hoja == 'PROPIA' && this.security_papers.length == 0){
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Debe registrar las hojas de seguridad a usar.'
                    })
                }else if(this.user.unionize == null) {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Actualmente no es agremiado.'
                    })
                }else if(this.form.amount == 0) {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Debe colocar el monto de la Actuación'
                    })
                }else if(this.document_price == 0 || this.document_price == '') {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Actualmente no podemos procesar su solicitud, Intente mas tarde!'
                    })
                }else if(this.form.cpc == ''){
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Debe ser agremiado para solicitar una actuacion'
                    })
                }else {
                    this.$emit('loadingResponse', true)
                    this.form.security_papers = this.security_papers
                    //await this.$store.dispatch('submitNewRuap', this.form)
                    if (this.form.tipo_hoja == 'SIN HOJAS' || this.form.tipo_hoja == 'PROPIA') {
                        // this.form.dr = 0
                        this.form.cantidad = null
                    }
                    await axios.post(`/api/sat/store`, this.form).then(resp => {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'Nueva actuacion profesional creada!'
                        })
                        this.$emit('nuevaActuacionResponse', resp.data)
                        this.$nextTick(() => {
                            this.form = {
                                cpc: '',
                                document_type: '',
                                client: '',
                                number_id: '',
                                subject: '',
                                date: '',
                                pages: '',
                                amount: '',
                                cantidad: null
                            }
                            // this.$refs.formnewactuacion.resetValidation()
                        })
                    }).catch(error => {
                        console.log(error.response)
                        this.$emit('loadingResponse', false)
                        if(error.response.data.errors){
                            if(error.response.data.errors.cpc){
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: error.response.data.errors.cpc
                                })
                            }
                        }else {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: 'Error. intente mas tarde.'
                            })
                        }
                    })
                }
            }
        }

    }

}

</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/FormNuevaActuacion.vue